module.exports = lib_typedi;